module.exports = __webpack_public_path__ + "img/ab.edb9cf5d.jpg";